// extracted by mini-css-extract-plugin
export default {"container":"style__container--_xJIF","heading":"style__heading--c63f7","list":"style__list--hI4lK"};